import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import {
  NbDialogService,
  NbGlobalLogicalPosition,
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
  NbToastrService,
} from '@nebular/theme';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, interval } from 'rxjs';
import { NbAuthJWTToken, NbAuthService, NbAuthResult, NbTokenService } from '@nebular/auth';
import { RegistrarAcessoService } from '../../../shared/services/registrar-acesso';
import { CustomPopupTrocarSenhaComponent } from './components/custom-popup-trocar-senha/custom-popup-trocar-senha.component';
import { CompromissosCacheService } from '../../../shared/services/compromissos-cache.service';
import { CompromissosCustomizadosCacheService } from '../../../shared/services/compromissos-customizados-cache.service';
import { AgendaCompromissosComponent } from './components/agenda-compromissos/agenda-compromissos.component';
import { PermissoesAcessoServices } from '../../../shared/services/permissoes-acesso.service';
import { EstruturaPermissoesAcessoResult } from '../../../shared/Results/EstruturaPermissoesAcessoResult';
import { TooltipService, ToolTipsAvailable } from '../../../shared/services/tooltip.service';
import { DynamicSelectComponent } from '../../../pages/extra-components/form-generico/form-generico.component';
import { FormDataService } from '../../../../services/v6/FormController/form-data.service';
import { StorageService } from '../../../shared/services/storage.service';
import { MudarPerfilUsuarioComponent } from '../../../pages/menu-header/mudar-perfil-usuario/mudar-perfil-usuario.component';
import { EPermissoesUnitarias } from '../../../shared/Enums/EPermissoesUnitarias';
import { PerfilUsuarioDataService } from '../../../pages/perfil-usuario/shared/services/PerfilUsuarioController/perfilUsuario-data.service';
import { EMenuSistema } from '../../../shared/Enums/EMenuSistema';
import { ETelaSistema } from '../../../shared/Enums/ETelaSistema';
import { TermometroDataFechamentoComponent } from './components/termometro-data-fechamento/termometro-data-fechamento.component';
import { RequestTokenService } from '../../../../services/request-token.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('agendaComponent') agendaComponent: AgendaCompromissosComponent;
  @ViewChild(TermometroDataFechamentoComponent)
  termometroFechamentoComp: TermometroDataFechamentoComponent;

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  picture: string;
  usuarioId: string;

  ehExecutivo: boolean = false;

  tipoTema: string = 'Claro';
  posicaoTema: string = 'start';

  mostrarAgendaCompromissos: boolean = false;
  temCompromissosHoje: boolean = false;
  proximoCompromisso: any = null;
  private verificacaoPeriodicaInterval: any;

  permissoesAcesso: EstruturaPermissoesAcessoResult;
  /** Evita disparar várias vezes carregar compromissos + intervalo ao detectar permissão de agenda. */
  private agendaHeaderCompromissosInicializada = false;
  private ultimoUsuarioIdParaAgendaHeader: string | null = null;
  temCompromissosCustomizadosHoje: boolean = false;

  mostrarTooltipEstrela: boolean = false;
  appointmentStarTooltipService: TooltipService = null;

  mostrarTooltipNotificacao: boolean = false;
  notificacaoTooltipService: TooltipService = null;
  private dicaNotificacaoFoiExibidaNestaSessao = false;

  /** Sino do header: usa `GetNotificacaoPendentes` via `ngx-notificacoes` (não a lista completa). */
  readonly headerNotificacoesUsaApiPendentes = true;

  /** Evita `CarregaDataUltimoFechamentoExecutivo` (e dicas duplicadas) quando `onTokenChange` emite mais de uma vez com o mesmo usuário. */
  private chaveCarregamentoIndicadorFechamento: string | null = null;

  // Connectivity detection properties
  conectividadeRuim: boolean = false;
  limiteTempoConexaoMs: number = 400;
  private intervaloVerificacaoConexao: any;

  // Session expiration warning properties
  mostrarAvisoExpiracao: boolean = false;
  tempoRestanteMinutos: number = 0;
  sessaoExpirada: boolean = false;
  private intervaloVerificacaoSessao: any;
  private limiteAvisoMinutos: number = 5; // Show warning 5 minutes before expiration

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Default',
    },
  ];
  currentTheme = 'default';

  private _userMenuItems = [
    { title: 'Perfil', link: '/pages/perfil-usuario' },
    { title: 'Análise Clientes', link: '/pages/negocio/analise-clientes' },
    { title: 'Mudar perfil' },
    { title: 'Sair', link: '/auth/logout' }
  ];

  private menuPermissoesMap: Map<string, EPermissoesUnitarias> = new Map([
    ['Mudar perfil', EPermissoesUnitarias.MudarPerfil],
    ['Análise Clientes', EPermissoesUnitarias.AnaliseClientes],
  ]);

  get userMenu() {
    return this._userMenuItems.filter(item => {
      // Verificação especial para o item "Perfil" - usa permissão de tela
      if (item.title === 'Perfil') {
        const permissoesTela = this.permissoesAcessoServices.getPermissoesAcessoTelaFromSession(
          EMenuSistema.PerfilUsuario,
          ETelaSistema.PerfilUsuario
        );
        // Verifica se tem permissão de consultar (índice 0)
        return permissoesTela[0];
      }

      // Para outros itens, verifica permissão unitária
      const permissaoRequerida = this.menuPermissoesMap.get(item.title);

      if (!permissaoRequerida) {
        return true;
      }

      return this.temPermissao(permissaoRequerida);
    });
  }

  listaPermissoesUnitarias: any[] = [];
  listaPermissoesUnitariasTipoUsuario: any[] = [];
  private onImagemPerfilAtualizada: () => void;
  private readonly onPermissoesUnitariasCarregadas = () => {
    this.aplicarPermissoesUnitariasDaSessao();
    this.cdr.markForCheck();
    this.configurarAgendaSePermitido();
  };

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private authService: NbAuthService,
    private tokenService: NbTokenService,
    private registrarAcessoService: RegistrarAcessoService,
    private dialogService: NbDialogService,
    private compromissosCacheService: CompromissosCacheService,
    private compromissosCustomizadosService: CompromissosCustomizadosCacheService,
    private permissoesAcessoServices: PermissoesAcessoServices,
    private formDataService: FormDataService,
    private storageService: StorageService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private perfilUsuarioDataService: PerfilUsuarioDataService,
    private requestTokenService: RequestTokenService,
    private toastrService: NbToastrService,
  ) {
    this.appointmentStarTooltipService = new TooltipService(ToolTipsAvailable.AppointmentStarTooltip);
    this.notificacaoTooltipService = new TooltipService(ToolTipsAvailable.HeaderNotificacaoTooltip);
    this.aplicarPermissoesUnitariasDaSessao();
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    window.addEventListener('ngx-permissoes-unitarias-carregadas', this.onPermissoesUnitariasCarregadas);

    // Fallback: pages.component grava permissões via HTTP — pode atrasar além do primeiro ciclo do header
    setTimeout(() => {
      this.aplicarPermissoesUnitariasDaSessao();
      this.cdr.detectChanges();
      this.configurarAgendaSePermitido();
    }, 1000);

    // Start connectivity monitoring
    this.iniciarMonitoramentoConectividade();

    // Start session expiration monitoring
    this.iniciarMonitoramentoSessao();

    // Listen for clicks outside tooltip to close it
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      let mudou = false;
      if (this.mostrarTooltipEstrela && !target.closest('.star-tooltip') && !target.closest('.appointment-star')) {
        this.mostrarTooltipEstrela = false;
        mudou = true;
      }
      if (this.mostrarTooltipNotificacao && !target.closest('.header-edu-tooltip--notificacao') && !target.closest('.header-notificacoes-wrap')) {
        this.mostrarTooltipNotificacao = false;
        this.dicaNotificacaoFoiExibidaNestaSessao = true;
        mudou = true;
      }
      if (mudou) {
        this.cdr.detectChanges();
      }
    });

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    this.authService.onTokenChange()
      .pipe(takeUntil(this.destroy$))
      .subscribe((token: NbAuthJWTToken) => {

        if (token.isValid()) {
          this.user = token.getPayload();

          const usuarioIdToken = String(this.user.usuarioId ?? '');
          if (this.ultimoUsuarioIdParaAgendaHeader !== usuarioIdToken) {
            this.ultimoUsuarioIdParaAgendaHeader = usuarioIdToken;
            this.agendaHeaderCompromissosInicializada = false;
          }

          sessionStorage.setItem('tipoUsuario', this.user.tipoUsuario);
          sessionStorage.setItem('usuarioId', this.user.usuarioId);
          sessionStorage.setItem('nomeUsuario', this.user.userName);
          sessionStorage.setItem('requestSenha', this.user.requestPassword);
          sessionStorage.setItem('emailUsuario', this.user.emailUsuario);
          this.usuarioId = this.user.usuarioId;
          
          this.ehExecutivo = String(sessionStorage.getItem('tipoUsuario')) === '1';

          const chaveToken = `${String(this.user.usuarioId)}:${String(this.user.tipoUsuario ?? '')}`;
          if (this.chaveCarregamentoIndicadorFechamento !== chaveToken) {
            this.chaveCarregamentoIndicadorFechamento = chaveToken;
            this.cdr.detectChanges();
            // Dados vêm do filho (ngOnChanges): com *ngIf por permissão, o ViewChild muitas vezes ainda não existe aqui.
            this.agendarDicasIconesHeader();
          }

          // Carrega a imagem do perfil usando o serviço
          this.carregarImagemPerfilUsuario();

          if (sessionStorage.getItem('registrarUsuario') == null || sessionStorage.getItem('registrarUsuario') == 'null') {
            this.registrarAcessoService.registerUserIP(null);
            sessionStorage.setItem('registrarUsuario', 'true');
          }

          if (this.user.requestPassword === 'true') {
            this.abrirPopupTrocarSenha();
          }

          this.permissoesAcesso = this.permissoesAcessoServices.getPermissoesAcessoFromSession();
          this.aplicarPermissoesUnitariasDaSessao();
          this.cdr.detectChanges();

          // Precarregar formulários se necessário
          this.iniciarPrecarregamentoFormularios();

          this.configurarAgendaSePermitido();
        } else {
          this.chaveCarregamentoIndicadorFechamento = null;
          this.ultimoUsuarioIdParaAgendaHeader = null;
          this.agendaHeaderCompromissosInicializada = false;
        }
      });

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    // Escutar cliques no menu do usuário
    this.menuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        console.log('Menu item clicked:', event.item.title); // Debug
        if (event.item.title === 'Mudar perfil') {
          this.abrirPopupMudarPerfil();
        } else if (event.item.title === 'Sair') {
          this.fazerLogout();
        }
      });

    // Escutar evento de atualização de imagem do perfil
    this.onImagemPerfilAtualizada = () => {
      this.carregarImagemPerfilUsuario(true);
    };
    window.addEventListener('imagemPerfilAtualizada', this.onImagemPerfilAtualizada);
  }

  verificarCompromissosHoje(): void {
    this.temCompromissosCustomizadosHoje = false;
    this.compromissosCacheService.carregarCompromissos(true)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        compromissos => {
          const compromissosHoje = this.compromissosCacheService.obterCompromissosHoje();
          let now = new Date();
          now.setHours(now.getHours() - 1);
          const compromissosFuturosHoje = compromissosHoje.filter(c => new Date(c.dtRetorno) >= now).sort((a, b) => new Date(a.dtRetorno).getTime() - new Date(b.dtRetorno).getTime());
          if (compromissosFuturosHoje.length == 0) {
            this.verificarCompromissosCustomizados(compromissosFuturosHoje);
          } else {
            this.temCompromissosHoje = true;
            this.proximoCompromisso = compromissosFuturosHoje[0];

            this.mostrarTooltipEstrelaSeNecessario();
          }
        },
        error => {
          console.error('Erro ao verificar compromissos de hoje:', error);
        }
      );
  }

  verificarCompromissosCustomizados(compromissosClienteHoje: any[]): void {
    this.compromissosCustomizadosService.carregarCompromissos(true)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        compromissosCustomizados => {
          const compromissosCustomizadosHoje = this.compromissosCustomizadosService.obterCompromissosHoje();
          let now = new Date();
          now.setHours(now.getHours() - 1);
          const compromissosCustomizadosFuturosHoje = compromissosCustomizadosHoje.filter(c =>
            c.data_compromisso && new Date(c.data_compromisso) >= now
          ).sort((a, b) => new Date(a.data_compromisso!).getTime() - new Date(b.data_compromisso!).getTime());

          this.temCompromissosHoje = compromissosCustomizadosFuturosHoje.length > 0;

          this.proximoCompromisso = this.temCompromissosHoje ? compromissosCustomizadosFuturosHoje[0] : null;
          this.temCompromissosCustomizadosHoje = true;

          if (this.temCompromissosHoje) {
            this.mostrarTooltipEstrelaSeNecessario();
          }
        },
        error => {
          console.error('Erro ao verificar compromissos customizados de hoje:', error);
          this.temCompromissosHoje = compromissosClienteHoje.length > 0;
          this.proximoCompromisso = this.temCompromissosHoje ? compromissosClienteHoje[0] : null;
        }
      );
  }

  iniciarVerificacaoPeriodica(): void {
    if (this.verificacaoPeriodicaInterval) {
      clearInterval(this.verificacaoPeriodicaInterval);
      this.verificacaoPeriodicaInterval = null;
    }
    this.verificacaoPeriodicaInterval = setInterval(() => {
      if (this.user && this.user.usuarioId) {
        this.verificarCompromissosHoje();
      }
    }, 10 * 60 * 1000); // 10 minutos
  }

  abrirAgendaCompromissos(): void {
    this.mostrarAgendaCompromissos = true;
    setTimeout(() => {
      if (this.agendaComponent) {
        this.agendaComponent.inicializar();
      }
    });
  }

  abrirProximoCompromisso(): void {
    if (this.proximoCompromisso) {
      this.mostrarAgendaCompromissos = true;
      setTimeout(() => {
        if (this.agendaComponent) {
          if (this.temCompromissosCustomizadosHoje) {
            this.agendaComponent.abrirCompromissoCustomizado(this.proximoCompromisso);
          } else {
            this.agendaComponent.abrirCompromissoEspecifico(this.proximoCompromisso);
          }
        }
      });
    }
  }

  fecharAgendaCompromissos(): void {
    this.mostrarAgendaCompromissos = false;
  }

  atualizarCompromissos(): void {
    this.compromissosCacheService.carregarCompromissos(true)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.agendaComponent) {
          this.agendaComponent.atualizarDados();
        }
        this.verificarCompromissosHoje();
      });
  }

  get habilitarBotaoAniversario(): boolean {
    // Verifica se o usuário tem permissão para ver aniversários
    // Retornamos true por padrão, mas você pode adicionar lógica de permissão aqui
    const tipoUsuario = sessionStorage.getItem('tipoUsuario');
    return tipoUsuario !== null;
  }

  mudarTema() {
    if (this.tipoTema == 'Escuro') {
      this.tipoTema = 'Claro';
      this.posicaoTema = 'start'
      this.themeService.changeTheme('default');
    } else {
      this.themeService.changeTheme('dark');
      this.tipoTema = 'Escuro';
      this.posicaoTema = 'end'
    }
  }

  private iniciarMonitoramentoConectividade(): void {
    this.verificarConectividade();

    this.intervaloVerificacaoConexao = setInterval(() => {
      this.verificarConectividade();
    }, this.conectividadeRuim ? 30000 : 10000); // Se conexão ruim, verifica a cada 30s, senão a cada 10s
  }

  private async verificarConectividade(): Promise<void> {
    try {
      const inicio = performance.now();

      const response = await fetch('https://www.google.com/favicon.ico', {
        method: 'HEAD',
        mode: 'no-cors',
        cache: 'no-store'
      });

      const tempoDecorrido = performance.now() - inicio;

      this.conectividadeRuim = tempoDecorrido > this.limiteTempoConexaoMs;
    } catch (error) {
      // Se houver erro na requisição, marca como conexão ruim
      this.conectividadeRuim = true;
    }
  }

  private iniciarMonitoramentoSessao(): void {
    // Verifica a sessão a cada minuto
    this.intervaloVerificacaoSessao = setInterval(() => {
      this.verificarExpiracaoSessao();
    }, 60000); // 1 minuto

    // Faz a primeira verificação imediatamente
    this.verificarExpiracaoSessao();

    // Subscribe to token changes to update when user re-authenticates
    this.authService.onTokenChange()
      .pipe(takeUntil(this.destroy$))
      .subscribe((token: NbAuthJWTToken) => {
        if (token && token.isValid()) {
          // Token foi renovado/atualizado, verifica a expiração novamente
          this.verificarExpiracaoSessao();

          // Notifica outras abas sobre a renovação do token
          this.notificarOutrasAbas('token-renovado');
        }
      });

    // Listen for storage events from other tabs (inter-tab communication)
    window.addEventListener('storage', (event) => {
      if (event.key === 'session-updated' && event.newValue) {
        // Outra aba renovou o token, atualiza esta aba
        this.verificarExpiracaoSessao();

        // Limpa a flag de notificação
        localStorage.removeItem('session-updated');
      }

      // Detecta login em outra aba: NbAuth armazena o token em 'auth_app_token'
      if (event.key === 'auth_app_token' && event.newValue) {
        try {
          const parsed = JSON.parse(event.newValue);
          if (parsed && parsed.value) {
            const createdAt = parsed.createdAt ? new Date(parsed.createdAt) : new Date();
            const newToken = new NbAuthJWTToken(parsed.value, 'email', createdAt);
            if (newToken.isValid()) {
              // Atualiza o BehaviorSubject interno do NbAuth com o token da outra aba
              this.tokenService.set(newToken);
              this.verificarExpiracaoSessao();
              this.cdr.detectChanges();
            }
          }
        } catch (e) {
          console.error('Erro ao processar token de outra aba:', e);
        }
      }
    });
  }

  private notificarOutrasAbas(evento: string): void {
    // Usa localStorage para notificar outras abas
    // O evento 'storage' só dispara em outras abas, não na atual
    localStorage.setItem('session-updated', `${evento}-${Date.now()}`);

    // Remove imediatamente para permitir futuras notificações
    setTimeout(() => {
      localStorage.removeItem('session-updated');
    }, 100);
  }

  private verificarExpiracaoSessao(): void {
    this.authService.getToken().subscribe((token: NbAuthJWTToken) => {
      if (token && token.isValid()) {
        const expDate = token.getTokenExpDate();
        if (expDate) {
          const agora = new Date();
          const diferencaMs = expDate.getTime() - agora.getTime();
          const diferencaMinutos = Math.floor(diferencaMs / 60000);

          this.tempoRestanteMinutos = diferencaMinutos;

          // Mostra aviso se faltar menos de X minutos e ainda não está mostrando
          if (diferencaMinutos <= this.limiteAvisoMinutos && diferencaMinutos > 0) {
            this.mostrarAvisoExpiracao = true;
            this.sessaoExpirada = false;
          } else if (diferencaMinutos <= 0) {
            // Sessão expirada - mostra mensagem diferente
            this.mostrarAvisoExpiracao = true;
            this.sessaoExpirada = true;
          } else {
            // Mais de X minutos restantes, esconde o aviso
            this.mostrarAvisoExpiracao = false;
            this.sessaoExpirada = false;
          }
        }
      } else {
        // Token inválido ou não existe - sessão expirada
        this.mostrarAvisoExpiracao = true;
        this.sessaoExpirada = true;
        this.tempoRestanteMinutos = 0;
      }
    });
  }

  dispensarAvisoExpiracao(): void {
    this.mostrarAvisoExpiracao = false;
  }

  onRenovarSessaoClick(): void {
    const pos = NbGlobalLogicalPosition.TOP_END;
    this.requestTokenService.renovarToken().subscribe({
      next: (result: NbAuthResult) => {
        if (result.isSuccess()) {
          window.location.reload();
          return;
        }
        const msg =
          result.getErrors().filter(Boolean).join(' ') ||
          'Não foi possível renovar. Faça login novamente.';
        this.toastrService.warning(msg, 'Renovar sessão', { position: pos });
      },
      error: () => {
        this.toastrService.danger('Erro ao renovar a sessão.', 'Renovar sessão', { position: pos });
      },
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    sessionStorage.removeItem('registrarUsuario');

    // Limpar verificação periódica de compromissos
    if (this.verificacaoPeriodicaInterval) {
      clearInterval(this.verificacaoPeriodicaInterval);
    }

    if (this.intervaloVerificacaoConexao) {
      clearInterval(this.intervaloVerificacaoConexao);
    }

    // Remover listener de atualização de imagem
    window.removeEventListener('ngx-permissoes-unitarias-carregadas', this.onPermissoesUnitariasCarregadas);

    if (this.onImagemPerfilAtualizada) {
      window.removeEventListener('imagemPerfilAtualizada', this.onImagemPerfilAtualizada);
    }

    if (this.intervaloVerificacaoSessao) {
      clearInterval(this.intervaloVerificacaoSessao);
    }
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  excluirListaNegocioCache() {
    caches.open(`negocio-cache-${this.usuarioId}`).then(function (cache) {
      cache.delete(`/negocio-cache-${this.usuarioId}`).then(function (success) { });
    });
  }

  abrirPopupTrocarSenha() {
    this.dialogService.open(CustomPopupTrocarSenhaComponent, {
      dialogClass: 'custom-dialog',
      closeOnEsc: false,
      closeOnBackdropClick: false,
      hasBackdrop: true,
      context: {

      }
    });
  }

  abrirPopupMudarPerfil() {
    this.dialogService.open(MudarPerfilUsuarioComponent, {
      dialogClass: 'custom-dialog',
      closeOnEsc: true,
      closeOnBackdropClick: true,
      hasBackdrop: true,
      context: {}
    });
  }

  fazerLogout() {
    // Obter usuarioId antes de limpar sessionStorage
    const usuarioId = sessionStorage.getItem('usuarioId');
    const tipoUsuario = sessionStorage.getItem('tipoUsuario');

    // Limpar cache de negócios se necessário (antes de limpar sessionStorage)
    if (usuarioId && tipoUsuario !== '1') { // Tipo 1 = Executivo, não precisa limpar cache
      caches.open(`negocio-cache-${usuarioId}`).then((cache) => {
        cache.delete(`/negocio-cache-${usuarioId}`).catch(error => {
          console.error('Erro ao deletar cache:', error);
        });
      }).catch(error => {
        console.error('Erro ao abrir cache:', error);
      });
    }

    // Limpar sessionStorage
    sessionStorage.clear();
    this.chaveCarregamentoIndicadorFechamento = null;
    this.ultimoUsuarioIdParaAgendaHeader = null;
    this.agendaHeaderCompromissosInicializada = false;

    // Fazer logout através do serviço de autenticação
    this.authService.logout('email').subscribe((result: NbAuthResult) => {
      // Sempre redirecionar para login após logout
      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, 0);
    }, (error) => {
      // Mesmo em caso de erro, redirecionar para login
      console.error('Erro ao fazer logout:', error);
      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, 0);
    });
  }

  /**
   * Igual ao termômetro e demais itens: permissão pode vir por tipo de usuário OU por usuário (`pages.component` grava duas listas).
   * Getter + `carregarPermissoesUnitarias` a cada avaliação alinham com `garantirPermissoesCarregadas` usado em `temPermissao`.
   */
  get temPermissaoAgenda(): boolean {
    this.carregarPermissoesUnitarias();
    const tem =
      this.listaContemPermissaoUnitaria(this.listaPermissoesUnitariasTipoUsuario, EPermissoesUnitarias.Agenda) ||
      this.listaContemPermissaoUnitaria(this.listaPermissoesUnitarias, EPermissoesUnitarias.Agenda);
    if (!tem) {
      this.agendaHeaderCompromissosInicializada = false;
    } else if (!this.agendaHeaderCompromissosInicializada) {
      queueMicrotask(() => this.configurarAgendaSePermitido());
    }
    return tem;
  }

  /** Lê sessionStorage e atualiza listas em memória. */
  private aplicarPermissoesUnitariasDaSessao(): void {
    this.carregarPermissoesUnitarias();
  }

  /** Compromissos e intervalo só após saber que há permissão de agenda. */
  private configurarAgendaSePermitido(): void {
    if (!this.temPermissaoAgenda) {
      return;
    }
    if (this.agendaHeaderCompromissosInicializada) {
      return;
    }
    this.agendaHeaderCompromissosInicializada = true;
    this.verificarCompromissosHoje();
    this.iniciarVerificacaoPeriodica();
  }

  private listaContemPermissaoUnitaria(lista: any[] | undefined | null, permissao: EPermissoesUnitarias): boolean {
    if (!lista?.length) {
      return false;
    }
    const codigo = Number(permissao);
    return lista.some(item => Number(item) === codigo);
  }

  mostrarTooltipEstrelaSeNecessario(): void {
    if (this.appointmentStarTooltipService.shouldShowTooltip()) {
      setTimeout(() => {
        this.mostrarTooltipEstrela = true;
      }, 500); // Show tooltip after 0.5 seconds
    }
  }

  fecharTooltipEstrela(dontShowAgain: boolean = false): void {
    this.mostrarTooltipEstrela = false;
    this.appointmentStarTooltipService.dismissTooltip(dontShowAgain);
  }

  /** Dicas didáticas (termômetro e sino), no estilo da estrela da agenda — textos calmos, sem pressão. */
  private agendarDicasIconesHeader(): void {
    setTimeout(() => this.termometroFechamentoComp?.agendarDicaSeNecessario(), 2200);
    setTimeout(() => this.mostrarTooltipNotificacaoSeNecessario(), 12000);
  }

  onFechouDicaTermometro(): void {
    setTimeout(() => this.mostrarTooltipNotificacaoSeNecessario(), 500);
  }

  mostrarTooltipNotificacaoSeNecessario(): void {
    if (!this.notificacaoTooltipService.shouldShowTooltip() || this.dicaNotificacaoFoiExibidaNestaSessao) {
      return;
    }
    if (this.mostrarTooltipNotificacao) {
      return;
    }
    if (this.termometroFechamentoComp?.estaDicaTermometroAberta) {
      setTimeout(() => this.mostrarTooltipNotificacaoSeNecessario(), 4000);
      return;
    }
    this.mostrarTooltipNotificacao = true;
    this.cdr.markForCheck();
  }

  fecharTooltipNotificacao(dontShowAgain: boolean = false): void {
    this.mostrarTooltipNotificacao = false;
    this.dicaNotificacaoFoiExibidaNestaSessao = true;
    this.notificacaoTooltipService.dismissTooltip(dontShowAgain);
    this.cdr.markForCheck();
  }

  /**
   * Inicia o precarregamento de formulários se necessário
   * Verifica se deve precarregar (novo dia ou primeiro acesso) e executa em background
   */
  private iniciarPrecarregamentoFormularios(): void {
    // Verifica se deve precarregar (diariamente)
    if (DynamicSelectComponent.verificarSeDevePrecarregar(this.storageService)) {
      // Executa precarregamento em background (não bloqueia a UI)
      setTimeout(() => {
        this.executarPrecarregamentoFormularios();
      }, 2000); // Aguarda 2 segundos para não sobrecarregar o startup
    }
  }

  /**
   * Executa o precarregamento de todos os formulários
   */
  private async executarPrecarregamentoFormularios(): Promise<void> {
    try {
      const sucesso = await DynamicSelectComponent.precarregarTodosFormularios(
        this.formDataService,
        this.storageService
      );
    } catch (error) {
      console.error('[HeaderComponent] ✗ Erro no precarregamento de formulários:', error);
    }
  }

  /**
   * Carrega as permissões unitárias do sessionStorage
   */
  private carregarPermissoesUnitarias(): void {
    const listaPermissoesUnitariasString = sessionStorage.getItem('permissoesUnitarias');
    if (listaPermissoesUnitariasString != null && listaPermissoesUnitariasString !== 'null') {
      try {
        this.listaPermissoesUnitarias = JSON.parse(listaPermissoesUnitariasString);
      } catch (error) {
        console.error('Erro ao parsear permissoesUnitarias:', error);
        this.listaPermissoesUnitarias = [];
      }
    }

    const listaPermissoesUnitariasTipoUsuarioString = sessionStorage.getItem('permissoesUnitariasTipoUsuario');
    if (listaPermissoesUnitariasTipoUsuarioString != null && listaPermissoesUnitariasTipoUsuarioString !== 'null') {
      try {
        this.listaPermissoesUnitariasTipoUsuario = JSON.parse(listaPermissoesUnitariasTipoUsuarioString);
      } catch (error) {
        console.error('Erro ao parsear permissoesUnitariasTipoUsuario:', error);
        this.listaPermissoesUnitariasTipoUsuario = [];
      }
    }
  }

  private garantirPermissoesCarregadas(): boolean {
    const rawTipo = sessionStorage.getItem('permissoesUnitariasTipoUsuario');
    const rawUsuario = sessionStorage.getItem('permissoesUnitarias');
    const temChaveTipo = rawTipo != null && rawTipo !== 'null';
    const temChaveUsuario = rawUsuario != null && rawUsuario !== 'null';

    if (!temChaveTipo && !temChaveUsuario) {
      return false;
    }

    const listasVazias =
      (!this.listaPermissoesUnitariasTipoUsuario || this.listaPermissoesUnitariasTipoUsuario.length === 0) &&
      (!this.listaPermissoesUnitarias || this.listaPermissoesUnitarias.length === 0);

    if (listasVazias) {
      this.carregarPermissoesUnitarias();
    }

    return (
      (this.listaPermissoesUnitariasTipoUsuario?.length ?? 0) > 0 ||
      (this.listaPermissoesUnitarias?.length ?? 0) > 0
    );
  }

  private carregarImagemPerfilUsuario(forcarRecarregamento: boolean = false) {
    if (!this.usuarioId) {
      return;
    }

    // Se forçar recarregamento, limpa o cache primeiro
    if (forcarRecarregamento) {
      sessionStorage.removeItem(`imagemUsuario_${this.usuarioId}`);
    }

    // Verifica se há imagem em cache no sessionStorage (apenas se não forçar recarregamento)
    if (!forcarRecarregamento) {
      const imagemCache = sessionStorage.getItem(`imagemUsuario_${this.usuarioId}`);
      if (imagemCache) {
        this.user.picture = imagemCache;
        this.cdr.detectChanges();
        return;
      }
    }

    // Busca a imagem da API
    this.perfilUsuarioDataService.CarregaImagemPerfilUsuario()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          let imagemBase64: string | null = null;

          // Trata diferentes formatos de resposta da API
          if (typeof response === 'string') {
            // Se a resposta for diretamente uma string base64
            imagemBase64 = response;
          } else if (response && response.imagemBase64) {
            // Se a resposta for um objeto com a propriedade imagemBase64
            imagemBase64 = response.imagemBase64;
          } else if (response && response.data) {
            // Se a resposta tiver uma propriedade data
            imagemBase64 = typeof response.data === 'string' ? response.data : response.data?.imagemBase64;
          }

          if (imagemBase64 && imagemBase64.trim() !== '') {
            // Se a API retornar apenas o base64 sem o prefixo, adiciona o prefixo
            if (!imagemBase64.startsWith('data:image/')) {
              // Assume PNG se não tiver o prefixo
              imagemBase64 = `data:image/png;base64,${imagemBase64}`;
            }

            this.user.picture = imagemBase64;

            // Cacheia no sessionStorage
            sessionStorage.setItem(`imagemUsuario_${this.usuarioId}`, imagemBase64);
            this.cdr.detectChanges();
          } else {
            // Se não tiver imagem na API, limpa o cache e deixa null
            sessionStorage.removeItem(`imagemUsuario_${this.usuarioId}`);
            this.user.picture = null;
            this.cdr.detectChanges();
          }
        },
        (error) => {
          console.error('Erro ao carregar imagem do perfil:', error);
          // Em caso de erro, limpa o cache e deixa null
          sessionStorage.removeItem(`imagemUsuario_${this.usuarioId}`);
          this.user.picture = null;
          this.cdr.detectChanges();
        }
      );
  }

  private temPermissao(permissao: EPermissoesUnitarias): boolean {
    if (!this.garantirPermissoesCarregadas()) {
      return false;
    }
    return (
      this.listaContemPermissaoUnitaria(this.listaPermissoesUnitariasTipoUsuario, permissao) ||
      this.listaContemPermissaoUnitaria(this.listaPermissoesUnitarias, permissao)
    );
  }

  get temPermissaoMudarPerfil(): boolean {
    return this.temPermissao(EPermissoesUnitarias.MudarPerfil);
  }

  get temPermissaoTermometro(): boolean {
    return this.temPermissao(EPermissoesUnitarias.Termometro);
  }

  get temPermissaoAnaliseClientes(): boolean {
    return this.temPermissao(EPermissoesUnitarias.AnaliseClientes);
  }
}
